import React from 'react';
import NotificationsHeaderItem from './header/desktopHeader/NotificationsHeaderItem';
import MessagesHeaderItem from './header/desktopHeader/MessagesHeaderItem';
import ProfileHeaderItem from './header/desktopHeader/ProfileHeaderItem';
import LanguageHeaderItem from './header/desktopHeader/LanguageHeaderItem';

function HeaderUserIcons({theme}: {theme: 'light' | 'dark'}): JSX.Element {
    return (
        <>
            <div className="c-header__icon">
                <NotificationsHeaderItem theme={theme} />
            </div>

            <div className="c-header__icon">
                <MessagesHeaderItem theme={theme} />
            </div>

            <div className="c-header__icon">
                <LanguageHeaderItem theme={theme} buttonIcon="solar:earth-linear" />
            </div>

            <div className="c-header__icon">
                <ProfileHeaderItem theme={theme} />
            </div>
        </>
    );
}

export default HeaderUserIcons;
